// extracted by mini-css-extract-plugin
export default {"filters":"gtQ7ihYqtcu4b1hZZxxV"};